import * as React from 'react';

import { useParams } from 'js/lib/useRouter';

import LearningPathBreadcrumbs from 'bundles/enterprise-learning-path-description-page/modules/LearningPathBreadcrumbs';
import type { EnterpriseLearningPathPageFieldsFragment } from 'bundles/enterprise-learning-path-description-page/queries/__generated__/EnterpriseLearningPathPageQuery';
import { useProgram } from 'bundles/unified-common/contexts/EnterpriseProgramContext';
import BreadcrumbsModule from 'bundles/unified-description-page-common/components/modules/breadcrumbs/BreadcrumbsModule';

type Props = {
  productTitle: string;
  pageData: EnterpriseLearningPathPageFieldsFragment;
};

const EnterpriseLearningPathBreadcrumbsModuleRenderer = ({ productTitle, pageData }: Props) => {
  const program = useProgram();
  const { badgeTemplateSlug } = useParams();

  if (!program || !program?.metadata) {
    return null;
  }

  if (!pageData.enterpriseBadge) {
    return null;
  }

  return (
    <BreadcrumbsModule
      breadcrumbs={
        <LearningPathBreadcrumbs
          programName={program.metadata?.name}
          programSlug={program.metadata?.slug}
          learningPathName={productTitle}
          // @ts-expect-error TS2322 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
          badgeTemplateSlug={badgeTemplateSlug}
        />
      }
    />
  );
};

export default EnterpriseLearningPathBreadcrumbsModuleRenderer;
